import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _fromJS;
import { fromJS } from 'immutable';
import { SET_QUIZ_ANALYSIS, SET_ITEM_ANALYSES, SET_STUDENT_ANALYSES, SET_ANALYSIS_FETCH_IN_PROGRESS, SET_STUDENT_ANALYSIS_FETCH_IN_PROGRESS, SET_ANALYSIS_GENERATION_IN_PROGRESS, SET_STUDENT_ANALYSIS_REPORT_GENERATION_IN_PROGRESS, SET_STATUS_POLLING_IN_PROGRESS, SET_STUDENT_ANALYSIS_STATUS_POLLING_IN_PROGRESS, SET_ANALYSIS_ERROR, SET_STUDENT_ANALYSIS_ERROR } from '@instructure/quiz-common';
export var quizAnalysisKey = 'quizAnalysis';
export var itemAnalysesKey = 'itemAnalyses';
export var studentAnalysesKey = 'studentAnalyses';
export var fetchInProgressKey = 'fetchInProgress';
export var studentAnalysisFetchInProgressKey = 'studentAnalysisFetchInProgress';
export var generationInProgressKey = 'generationInProgress';
export var studentAnalysisGenerationInProgressKey = 'studentAnalysisGenerationInProgress';
export var statusPollingInProgressKey = 'statusPollingInProgress';
export var studentAnalysisStatusPollingInProgressKey = 'studentAnalysisStatusPollingInProgress';
export var errorKey = 'analysisError';
export var studentAnalysisErrorKey = 'studentAnalysisError';
export var defaultState = fromJS((_fromJS = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_fromJS, quizAnalysisKey, void 0), itemAnalysesKey, void 0), studentAnalysesKey, void 0), fetchInProgressKey, true), studentAnalysisFetchInProgressKey, false), generationInProgressKey, false), studentAnalysisGenerationInProgressKey, false), statusPollingInProgressKey, false), studentAnalysisStatusPollingInProgressKey, false), errorKey, void 0), _defineProperty(_fromJS, studentAnalysisErrorKey, void 0)));
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case SET_QUIZ_ANALYSIS:
      return state.set(quizAnalysisKey, fromJS(action.payload));
    case SET_ITEM_ANALYSES:
      return state.set(itemAnalysesKey, fromJS(action.payload));
    case SET_STUDENT_ANALYSES:
      return state.set(studentAnalysesKey, fromJS(action.payload));
    case SET_ANALYSIS_FETCH_IN_PROGRESS:
      return state.set(fetchInProgressKey, action.payload);
    case SET_STUDENT_ANALYSIS_FETCH_IN_PROGRESS:
      return state.set(studentAnalysisFetchInProgressKey, action.payload);
    case SET_ANALYSIS_GENERATION_IN_PROGRESS:
      return state.set(generationInProgressKey, action.payload);
    case SET_STUDENT_ANALYSIS_REPORT_GENERATION_IN_PROGRESS:
      return state.set(studentAnalysisGenerationInProgressKey, action.payload);
    case SET_STATUS_POLLING_IN_PROGRESS:
      return state.set(statusPollingInProgressKey, action.payload);
    case SET_STUDENT_ANALYSIS_STATUS_POLLING_IN_PROGRESS:
      return state.set(studentAnalysisStatusPollingInProgressKey, action.payload);
    case SET_ANALYSIS_ERROR:
      return state.set(errorKey, action.payload);
    case SET_STUDENT_ANALYSIS_ERROR:
      return state.set(studentAnalysisErrorKey, action.payload);
    default:
      return state;
  }
});